import { TablePlaceholder } from 'shared/placeholders';
import { Table } from 'shared/table';
import { TableComponentParams } from 'shared/table/hoc/withPagination';
import { Usuario } from 'user/models/Usuario';
import { Button, Tooltip } from '@orbita-ui/core';

export interface UsersTableProps extends TableComponentParams<Usuario> {
  onDelete?: (usuario: Usuario) => void;
  onEdit?: (usuario: Usuario) => void;
  onInfo?: (usuario: Usuario) => void;
}

export const UsersTable = ({
  tableContent,
  onDelete,
  onEdit,
  onInfo,
}: UsersTableProps) => (
  <Table
    thead={
      <tr>
        <td>Código de usuario</td>
        <td>Detalle</td>
        <td>Cuenta controlada</td>
        <td></td>
      </tr>
    }
    tbody={
      <>
        {tableContent?.map((row) => (
          <tr key={row.username}>
            <td>{row.username}</td>
            <td>{row.detalle}</td>
            <td>{row.recursoControlado.numeroCuenta}</td>
            <td className="text-end">
              <Tooltip text="Información de usuario" position="left">
                <Button
                  onClick={() => onInfo(row)}
                  className="bg-secondary"
                  color="inverted"
                  variant="ghost"
                  icon="InfoIcon"
                  size="small"
                />
              </Tooltip>
              {!row.cuentaRaiz && (
                <>
                  <Tooltip text="Editar usuario" position="left">
                    <Button
                      onClick={() => onEdit(row)}
                      color="inverted"
                      icon="EditIcon"
                      size="small"
                    />
                  </Tooltip>
                  <Tooltip text="Eliminar usuario" position="left">
                    <Button
                      color="destructive"
                      icon="DeleteIcon"
                      size="small"
                      onClick={() => onDelete(row)}
                    />
                  </Tooltip>
                </>
              )}
            </td>
          </tr>
        )) || <TablePlaceholder cols={4} rows={5} />}
      </>
    }
  />
);
